import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="flex flex-col gap-6 py-12 items-center text-center" data-id="element-47">
      <ShieldCheckIcon className="w-16 h-16 text-[#0F4C3A]" data-id="element-48" />

      <h3 className="font-serif text-3xl font-bold text-[#0F4C3A]" data-id="element-49">
        🛡️ Garantía de 7 días
      </h3>

      <div className="flex flex-col gap-4 text-lg text-stone-700" data-id="element-50">
        <p data-id="element-51">Usalo una semana completa.</p>
        <p data-id="element-52">
          Si no llegás a cada sesión con más claridad más seguridad y menos
          tiempo preparando material fuera de hora te devolvemos el 100% del
          dinero.
        </p>
        <p className="font-bold text-stone-900" data-id="element-53">
          Sin preguntas. Sin formularios. Sin vueltas.
        </p>
      </div>
    </section>;
}